import React, { useState } from 'react';

function formatDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('fr-FR');
}

function formatDateTime(d) {
  if (!d) return '—';
  return new Date(d).toLocaleString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
}

function getMotifArchivage(commentairesJson) {
  if (!Array.isArray(commentairesJson) || commentairesJson.length === 0) return null;
  const last = [...commentairesJson].reverse().find(c =>
    typeof c.commentaire === 'string' && c.commentaire.startsWith('📦 Archivé')
  );
  if (last) return last.commentaire.replace(/^📦 Archivé\s*:\s*/, '').trim();
  // Fallback : dernier commentaire si pas de marqueur 📦
  const dernier = commentairesJson[commentairesJson.length - 1];
  return dernier?.commentaire || null;
}

function ArchiveItemDetail({ archive: a }) {
  const [showAll, setShowAll] = useState(false);

  const motif = getMotifArchivage(a.commentaires_json);
  const clientLabel = (a.nom || a.prenom)
    ? `${a.nom || ''} ${a.prenom || ''}`.trim()
    : (a.client || '—');
  const vehiculeLabel = [a.marque, a.modele].filter(Boolean).join(' ');
  const commentaires = Array.isArray(a.commentaires_json) ? a.commentaires_json : [];

  return (
    <div className="archive-item-detail">
      <div className="archive-item-head">
        <span className="archive-item-sujet">{a.sujet || 'Sans sujet'}</span>
        <span className="archive-item-dates">
          📅 demande {formatDate(a.date_demande)} · 📦 archivée {formatDate(a.date_archivage)}
        </span>
      </div>

      <div className="archive-item-grid">
        <div><span className="archive-item-label">Client</span><span>{clientLabel}</span></div>
        {a.responsable && <div><span className="archive-item-label">Responsable</span><span>{a.responsable}</span></div>}
        {a.telephone && <div><span className="archive-item-label">Tél.</span><span>{a.telephone}</span></div>}
        {a.immatriculation && <div><span className="archive-item-label">Immat.</span><span>{a.immatriculation}</span></div>}
        {vehiculeLabel && <div><span className="archive-item-label">Véhicule</span><span>{vehiculeLabel}</span></div>}
        {(a.nb_appels != null) && <div><span className="archive-item-label">Appels</span><span>{a.nb_appels}</span></div>}
      </div>

      {motif && (
        <div className="archive-item-motif">
          <span className="archive-item-label">Motif d'archivage</span>
          <span className="archive-item-motif-text">{motif}</span>
        </div>
      )}

      {a.synthese && (
        <div className="archive-item-synthese">
          <span className="archive-item-label">🤖 Synthèse</span>
          <span>{a.synthese}</span>
        </div>
      )}

      {commentaires.length > 0 && (
        <div className="archive-item-commentaires">
          <button
            type="button"
            className="archive-item-toggle"
            onClick={() => setShowAll(s => !s)}
          >
            {showAll ? '▾' : '▸'} {commentaires.length} commentaire{commentaires.length > 1 ? 's' : ''}
          </button>
          {showAll && (
            <ul className="archive-item-commentaires-list">
              {commentaires.map((c, i) => (
                <li key={i}>
                  <span className="archive-item-commentaire-meta">
                    {formatDateTime(c.created_at)}
                    {(c.user_prenom || c.user_nom) && ` — ${[c.user_prenom, c.user_nom].filter(Boolean).join(' ')}`}
                  </span>
                  <span className="archive-item-commentaire-text">{c.commentaire}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}

export default ArchiveItemDetail;
